export const titleMapping = {
  "zh-hk":
    "亞洲電商金融科技融資平台 l 中小企業",
  en: "FundPark - a digital financing platform for e-commerce SMEs in Asia",
};
